import { useContext } from 'react';
import { SkeletonBreadcrumbs } from '@/components/presentation/Breadcrumbs';
import { WorkspaceObjectBreadcrumbs } from '@/components/Workspace/ObjectBreadcrumbs';
import { BrandLoadingContext } from '@/containers/Workspace.Brand/Context';
import { useObjectBreadcrumbsContext } from '@/containers/WorkspaceObject/Context';
import styles from '@/screens/Workspace.File/style/Header.module.css';

export const BrandBreadcrumbs = () => {
  const breadcrumbs = useObjectBreadcrumbsContext();
  const isLoading = useContext(BrandLoadingContext);

  return (
    <>
      {isLoading
        ? <SkeletonBreadcrumbs />
        : (
          <div className={styles.breadcrumbs}>
            <WorkspaceObjectBreadcrumbs items={breadcrumbs} />
          </div>
        )
      }
    </>
  );
};